import { render, staticRenderFns } from "./SelfServicePasswordResetCard.vue?vue&type=template&id=58bfa914&scoped=true"
import script from "./SelfServicePasswordResetCard.vue?vue&type=script&lang=js"
export * from "./SelfServicePasswordResetCard.vue?vue&type=script&lang=js"
import style0 from "./SelfServicePasswordResetCard.vue?vue&type=style&index=0&id=58bfa914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58bfa914",
  null
  
)

export default component.exports